"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitArray = void 0;
const BACKING_TYPE = Uint8Array;
const ELEMENT_BITS = BACKING_TYPE.BYTES_PER_ELEMENT * 8;
class BitArray {
    constructor(lengthOrArray) {
        if (lengthOrArray instanceof BACKING_TYPE) {
            this.backingArray = lengthOrArray;
            this.length = lengthOrArray.length * ELEMENT_BITS;
        }
        else {
            this.backingArray = new BACKING_TYPE(Math.ceil(lengthOrArray / ELEMENT_BITS));
            this.length = lengthOrArray;
        }
    }
    get(index) {
        if (index >= this.length)
            return false;
        return (this.backingArray[(index / ELEMENT_BITS) | 0] & (1 << index % ELEMENT_BITS)) > 0;
    }
    on(index) {
        if (index >= this.length)
            return;
        this.backingArray[(index / ELEMENT_BITS) | 0] |= 1 << index % ELEMENT_BITS;
    }
    off(index) {
        if (index >= this.length)
            return;
        this.backingArray[(index / ELEMENT_BITS) | 0] &= ~(1 << index % ELEMENT_BITS);
    }
    toggle(index) {
        if (index >= this.length)
            return false;
        return !!(this.backingArray[(index / ELEMENT_BITS) | 0] ^= 1 << index % ELEMENT_BITS);
    }
    *all() {
        for (let i = 0; i < this.length; i++) {
            if (this.get(i)) {
                yield i;
            }
        }
    }
    toString(format) {
        if (!format) {
            return this.backingArray.toString();
        }
        return new Buffer(this.backingArray).toString(format);
    }
    static fromBase64(base64) {
        try {
            if (typeof Buffer !== 'undefined') {
                const backingArray = new BACKING_TYPE(Buffer.from(base64, 'base64'));
                return new BitArray(backingArray);
            }
            let binaryString = atob(base64);
            let len = binaryString.length;
            let bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return new BitArray(bytes);
        }
        catch (e) {
            console.error(e);
            return new BitArray(0);
        }
    }
}
exports.BitArray = BitArray;
//# sourceMappingURL=bit.array.js.map